module.exports = require('./lib/linkify-html').default;



//////////////////
// WEBPACK FOOTER
// ./~/vue-linkify/~/linkifyjs/html.js
// module id = 249
// module chunks = 0